/**
 * Точка входа webpack: landing.wordstat
 */
import './wordstat.css';
import '../../common.js';
import '../../modules/partners/partners.js';
import { initLandingVideo } from '../../modules/video/video.js';
import { initFaq } from '../../modules/faq/faq.js';
import '../../modules/tariffs/tariffs.js';
import { initReviews } from '../../modules/reviews/reviews.js';

function init() {
    initLandingVideo();
    initFaq();
    initReviews();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}